import React, { useContext } from 'react';
import { StyleSheet, View, Image, Text } from 'react-native';
import { ThemeContext } from '..';

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (theme: Theme, error: boolean): Record<string, Record<string, string | number | undefined>> => {
  const colors = error ? theme.toast.error : theme.toast.message;
  return StyleSheet.create({
    container: {
      alignItems: 'center',
      backgroundColor: theme.colors.white,
      borderRadius: 10,
      flexDirection: 'row',
      justifyContent: 'center',
      padding: 30,
    },
    image: {
      maxHeight: 80,
      maxWidth: 55,
    },
    text: {
      color: colors.text,
      fontWeight: theme.font.weight.bold,
      textAlign: 'center',
    },
    textWithImage: {
      color: colors.text,
      fontWeight: theme.font.weight.bold,
      marginLeft: 16,
      maxWidth: '80%',
      textAlign: 'left',
    },
  });
};

export const Toast = (props: Props): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme, props.error);

  return (
    <View style={[styles.container, props.style]}>
      {props.image && <Image source={props.image} style={styles.image} resizeMode="contain" />}
      <Text style={[props.image ? styles.textWithImage : styles.text, props.textStyle]}>{props.message}</Text>
    </View>
  );
};

type Props = {
  message: string;
  error: boolean;
  image?: number;
  style?: any;
  textStyle?: any;
};
